import { afterEvent, defineGameCard, roundMarkerStatus } from '../authoring/index.js';
import { isSlimeDefinitionId, SLIME_RESIDUE_ID, slimeSetDependencies, trail, } from './slime-helpers.js';
export const SampleCollectorCard = defineGameCard({
    id: 'sample_collector',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 2 }, traits: ['SLIME'] },
    presentation: {
        name: 'Сборщик образцов',
        description: 'След 1. Первый раз за раунд, когда другой ваш слизень поглощён, возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#3A624D', '#74AD4C', '#5E984F', '#EBF0D2'],
            rows: [
                '....................',
                '.......1111111......',
                '......122223221.....',
                '.....1223333341.....',
                '.....12333333321....',
                '.....12444344421....',
                '....124414441441....',
                '....123444344431....',
                '....123333333331....',
                '....1544333333221...',
                '...15554444422551...',
                '...15555554455551...',
                '...155555543555551..',
                '...155555534544451..',
                '..1554445534554451..',
                '..1554455334555551..',
                '..15555553332555551.',
                '..15555553344255551.',
                '.155555533444255551.',
                '.111111111111111111.',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeSetDependencies(SLIME_RESIDUE_ID),
    abilities: [
        trail(),
        // Типизированная подписка на Поглощение вместо широкого onAnyEvent (D53+);
        // legacyKey сохраняет прежний persisted vars key для publicVars/статуса.
        afterEvent({
            abilityId: 'sample_draw',
            event: 'CardsAbsorbed',
            frequency: 'first_per_round',
            legacyKey: 'sampleAbsorptionRound',
            when(ctx, event) {
                const self = ctx.self;
                return self !== undefined
                    && event.donors.some((donor) => donor.instanceId !== self.id
                        && donor.controllerId === self.controllerId
                        && isSlimeDefinitionId(donor.defId));
            },
            run(ctx) {
                if (ctx.self !== undefined)
                    ctx.ops.drawCard(ctx.self.controllerId, 1);
            },
        }),
    ],
    ui: {
        mechanics: ['trail', 'slime_residue', 'absorb'],
        publicVars: { sampleAbsorptionRound: { key: 'sampleAbsorptionRound', kind: 'number' } },
        statusProviders: [roundMarkerStatus({
                fact: 'sampleAbsorptionRound',
                id: 'sample-draw-used',
                symbol: '✓',
                label: 'Добор за Поглощение',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=sample_collector.js.map